<template>
  <div class="owner-help-page" data-testid="owner-help-page">
    <help-renderer audience="owner" base-path="/distributor/help/owner" />
  </div>
</template>

<script>
/**
 * Owner/distributor help surface -- mounted at `/distributor/help/owner[/:slug]`
 * inside the distributor route group, so it inherits the distributor's
 * existing auth guard and DistributorLayout chrome
 * (`docs/user/HELP-SYSTEM-DESIGN.md` decision 4).
 *
 * This wrapper is deliberately thin: all behavior lives in the ONE shared
 * HelpRenderer. The only thing that makes this surface "owner help" is the
 * audience it passes and the route group it is mounted in.
 */
import HelpRenderer from "@/components/Help/HelpRenderer.vue";

export default {
  name: "OwnerHelpPage",
  components: { HelpRenderer },
};
</script>
